import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const KnowledgeCards = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: 'async-knowledge-cards' */ './main')),
});
